(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-purchase-options"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatMoney(cents, symbol) {
      var amount = (cents / 100).toFixed(2);
      return (symbol || '') + amount;
    }

    function initPurchaseOptions(container) {
      var sectionEl = container.closest('section');
      if (!sectionEl) return;

      var quantityInput = sectionEl.querySelector('input[name="quantity"]');
      var variantInput = sectionEl.querySelector('select[name="id"], input[name="id"]');

      var oneTimePriceEl = container.querySelector('[data-one-time-price]');
      var subscribePriceEl = container.querySelector('[data-subscribe-price]');

      if (!oneTimePriceEl || !subscribePriceEl) return;

      var pricesAttr = container.getAttribute('data-variant-prices');
      if (!pricesAttr) return;

      var prices;
      try {
        prices = JSON.parse(pricesAttr);
      } catch (e) {
        return;
      }

      var symbol = container.getAttribute('data-currency-symbol') || '';

      function getQuantity() {
        if (!quantityInput) return 1;
        var value = parseInt(quantityInput.value || '1', 10);
        if (!value || value < 1) value = 1;
        return value;
      }

      function getVariantId() {
        if (!variantInput) return null;
        return variantInput.value;
      }

      function recalc() {
        var variantId = getVariantId();
        var qty = getQuantity();

        if (!variantId || !prices[variantId]) return;

        var basePriceCents = prices[variantId];
        var oneTimeTotalCents = basePriceCents * qty;
        var discountedTotalCents = Math.round(oneTimeTotalCents * 0.8);

        oneTimePriceEl.textContent = formatMoney(oneTimeTotalCents, symbol);
        subscribePriceEl.textContent = formatMoney(discountedTotalCents, symbol);
      }

      // --- NEW: Active state for selected radio option ---
      var radios = container.querySelectorAll('.purchase-option__radio');
      var optionBlocks = container.querySelectorAll('.purchase-option');

      function updateActiveState() {
        optionBlocks.forEach(function (opt) {
          opt.classList.remove('purchase-option--active');
        });

        radios.forEach(function (radio) {
          if (radio.checked) {
            var opt = radio.closest('.purchase-option');
            if (opt) {
              opt.classList.add('purchase-option--active');
            }
          }
        });
      }

      // Initialize prices and active state
      recalc();
      updateActiveState();

      if (quantityInput) {
        quantityInput.addEventListener('change', function () {
          recalc();
        });
        quantityInput.addEventListener('input', function () {
          recalc();
        });
      }

      if (variantInput) {
        variantInput.addEventListener('change', function () {
          recalc();
        });
      }

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          updateActiveState();
        });
      });
    }

    function initAllPurchaseOptions() {
      var containers = document.querySelectorAll('[data-purchase-options]');
      containers.forEach(initPurchaseOptions);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllPurchaseOptions);
    } else {
      initAllPurchaseOptions();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quantity-variant-row"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }

      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD'
      }).format(cents / 100);
    }

    function initPQVBlock(blockEl) {
      if (blockEl.dataset.pqvInitialized === 'true') return;
      blockEl.dataset.pqvInitialized = 'true';

      var sectionId = blockEl.dataset.pqvSectionId;
      var quantityInput = blockEl.querySelector('.pqv-block__input--quantity');
      var minusBtn = blockEl.querySelector('.pqv-qty__btn--minus');
      var plusBtn = blockEl.querySelector('.pqv-qty__btn--plus');
      var variantSelect = blockEl.querySelector('[data-pqv-variant-select]');

      var sectionRoot =
        document.getElementById('shopify-section-' + sectionId) ||
        document.getElementById('MainProduct-' + sectionId) ||
        document;

      var productInfo =
        document.getElementById('MainProduct-' + sectionId) ||
        sectionRoot.querySelector('product-info[data-section="' + sectionId + '"]') ||
        sectionRoot.querySelector('product-info');

      var productForm =
        sectionRoot.querySelector('form[data-type="add-to-cart-form"]') ||
        sectionRoot.querySelector('product-form form[action*="/cart/add"]') ||
        sectionRoot.querySelector('form[action*="/cart/add"]');

      function getHiddenVariantInput() {
        if (!productForm) return null;

        return productForm.querySelector('input[name="id"]');
      }

      function getSelectedVariantOption() {
        if (!variantSelect) return null;

        return variantSelect.options[variantSelect.selectedIndex];
      }

      function getQuantity() {
        if (!quantityInput) return 1;

        var quantity = parseInt(quantityInput.value || '1', 10);

        return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
      }

      function getPriceWrapper() {
        return (
          document.getElementById('price-' + sectionId) ||
          sectionRoot.querySelector('#price-' + sectionId)
        );
      }

      function getPriceElement() {
        var priceWrapper = getPriceWrapper();

        if (!priceWrapper) return null;

        return (
          priceWrapper.querySelector('.price-item--sale') ||
          priceWrapper.querySelector('.price-item--regular') ||
          priceWrapper.querySelector('.price__sale .price-item') ||
          priceWrapper.querySelector('.price__regular .price-item')
        );
      }

      function updateDisplayedTotalPrice() {
        var selectedOption = getSelectedVariantOption();
        var priceElement = getPriceElement();

        if (!selectedOption || !priceElement) return;

        var basePrice = parseInt(selectedOption.dataset.price || '0', 10);
        var quantity = getQuantity();

        priceElement.textContent = formatMoney(basePrice * quantity);
      }

      function clampQuantity(value) {
        if (!quantityInput) return;

        var min = parseInt(quantityInput.getAttribute('min') || '1', 10);
        var maxAttr = quantityInput.getAttribute('max');
        var max = maxAttr ? parseInt(maxAttr, 10) : null;

        if (!value || value < min) value = min;
        if (max !== null && value > max) value = max;

        quantityInput.value = value;
      }

      function syncQuantityToDawnQuantityInput() {
        if (!quantityInput) return;

        var nativeQuantityInput = sectionRoot.querySelector(
          '#Quantity-' + sectionId + '[name="quantity"]'
        );

        if (!nativeQuantityInput || nativeQuantityInput === quantityInput) return;

        nativeQuantityInput.value = quantityInput.value;

        nativeQuantityInput.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }

      function syncVariantToDawnForm() {
        if (!variantSelect) return;

        var hiddenVariantInput = getHiddenVariantInput();

        if (!hiddenVariantInput) return;

        hiddenVariantInput.value = variantSelect.value;

        hiddenVariantInput.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }

      function handleQuantityChange() {
        if (!quantityInput) return;

        clampQuantity(parseInt(quantityInput.value || '1', 10));
        syncQuantityToDawnQuantityInput();
        updateDisplayedTotalPrice();
      }

      function handleVariantChange() {
        if (!variantSelect || !variantSelect.value) return;

        var nextUrl = new URL(window.location.href);

        nextUrl.searchParams.set('variant', variantSelect.value);

        if (nextUrl.href === window.location.href) return;

        window.location.assign(nextUrl.href);
      }

      if (minusBtn && quantityInput) {
        minusBtn.addEventListener('click', function () {
          var step = parseInt(quantityInput.step || '1', 10) || 1;
          var value = parseInt(quantityInput.value || '1', 10) - step;

          clampQuantity(value);
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      if (plusBtn && quantityInput) {
        plusBtn.addEventListener('click', function () {
          var step = parseInt(quantityInput.step || '1', 10) || 1;
          var value = parseInt(quantityInput.value || '1', 10) + step;

          clampQuantity(value);
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      if (quantityInput) {
        quantityInput.addEventListener('change', handleQuantityChange);
        quantityInput.addEventListener('input', handleQuantityChange);
      }

      if (variantSelect) {
        variantSelect.addEventListener('change', handleVariantChange);
      }

      syncVariantToDawnForm();
      handleQuantityChange();
    }

    function initPQVBlocks() {
      var blocks = document.querySelectorAll('[data-pqv-block]');

      blocks.forEach(initPQVBlock);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPQVBlocks);
    } else {
      initPQVBlocks();
    }

    document.addEventListener('shopify:section:load', initPQVBlocks);
  })();
  } catch(e) { console.error(e); }
})();

})();
